import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { VendedoresComponent } from "./ventas/vendedores/vendedores.component";
import { VendedoresClientesComponent } from "./ventas/vendedores-clientes/vendedores-clientes.component";
import { TerritoriosComponent } from "./ventas/territorios/territorios.component";

import { ProductosGeneralComponent } from "./productos/productos-general/productos-general.component";
import { ProductosAnualizadoComponent } from "./productos/productos-anualizado/productos-anualizado.component";
import { ReporteGeneralComponent } from "./productos/reporte-general/reporte-general.component";

import { MovimientoStockComponent } from './inventario/movimiento-stock/movimiento-stock.component';
import { ReporteInventarioGeneralComponent } from './inventario/general/general.component';
import { ReporteInventarioSaldoSKUMesComponent } from './inventario/saldo-sku-mes/saldo-sku-mes.component';
import { ReporteInventarioExistStockValorizadoComponent } from './inventario/exist-stock-valorizado/exist-stock-valorizado.component';
import { ExistMovimientoESComponent } from "./inventario/exist-movimiento-es/exist-movimiento-es.component";
import { ExistStockProductoComponent } from "./inventario/exist-stock-producto/exist-stock-producto.component";
import { TerritoriosAnualizadoComponent } from "./ventas/territorios-anualizado/territorios-anualizado.component";

import { DetalleProductosComponent } from "./cliente/detalle-productos/detalle-productos.component";
import { EspecificoComponent } from "./cliente/especifico/especifico.component";
import { VentasClientesComponent } from "./cliente/ventas-clientes/ventas-clientes.component";
import { LibroVentaComponent } from './ventas/libro-venta/libro-venta.component';
import { LibroCompraComponent } from './compras/libro-compra/libro-compra.component';
import { ConsultaDocumentoComponent } from './ventas/consulta-documento/consulta-documento.component';
import { VendedoresFamiliaComponent } from './ventas/vendedores-familia/vendedores-familia.component';
import { CoberturaIPTComponent } from './cliente/cobertura-ipt/cobertura-ipt.component';
import { SeleccionarVendedorComponent } from "./cliente/cobertura-ipt/seleccionar-vendedor/seleccionar-vendedor.component";
import { HistoricoQuiebresComponent } from "./historico-quiebres/historico-quiebres.component";

@NgModule({
  declarations: [
    VendedoresComponent,
    VendedoresClientesComponent,
    TerritoriosComponent,
    TerritoriosAnualizadoComponent,
    ProductosGeneralComponent,
    ProductosAnualizadoComponent,
    ReporteGeneralComponent,
    MovimientoStockComponent,
    ReporteInventarioGeneralComponent,
    ReporteInventarioSaldoSKUMesComponent,
    ReporteInventarioExistStockValorizadoComponent,
    ExistMovimientoESComponent,
    ExistStockProductoComponent,
    VentasClientesComponent,
    EspecificoComponent,
    DetalleProductosComponent,
    LibroVentaComponent,
    LibroCompraComponent,
    ConsultaDocumentoComponent,
    VendedoresFamiliaComponent,
    CoberturaIPTComponent,
    SeleccionarVendedorComponent,
    HistoricoQuiebresComponent
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule
  ],
  exports: [
    VendedoresComponent,
    VendedoresFamiliaComponent,
    VendedoresClientesComponent,
    TerritoriosComponent,
    TerritoriosAnualizadoComponent,
    MovimientoStockComponent,
    ReporteInventarioGeneralComponent,
    ReporteInventarioSaldoSKUMesComponent,
    ReporteInventarioExistStockValorizadoComponent,
    ExistMovimientoESComponent,
    ExistStockProductoComponent,
    HistoricoQuiebresComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportesModule { }
